import axios from "./axios";
const baseUrl = process.env.REACT_APP_API_URL;

const Request = (config) => {
  const token = localStorage.getItem("token");
  if (token) {
    if (typeof token !== "undefined" && token) {
      config.headers = { ...config.headers, Authorization: "Bearer "+token };
    }
  }
  config.url = baseUrl + config.url;
  return axios.request(config);
};
export default Request;
